import React, { Component } from 'react';
import { restRequest } from '../../../../../Helpers/RequestHelper';
import Loader from './../../../../../Components/Loader/Loader';
import TransactionsTable from './TransactionsTable';
import SubTabs from '../../../../../Components/Tabs/SubTabs';
import './ContactTransaction.css';
import EmptyTable from '../../../../../Components/ListTable/EmptyTable';
import TabsTable from '../../../../../Components/TabsTable/TabsTable';
import { checkError } from '../../../../../Helpers/AuthHelper';
import { t } from 'i18next';

class ContactTransactionTab extends Component {
  transactionTable = {
    sales_orders: {
      tableHeaders: [
        t('saleOrder.sales_order_no'),
        t('saleOrder.listing_columns.date'),
        t('saleOrder.reference'),
        t('saleOrder.amount'),
        t('saleOrder.listing_columns.status'),
      ],
      tableData: [
        'sales_order_no',
        'order_date',
        'reference',
        'total',
        'status',
      ],
      rightAlignColumns: [4],
      linkTo: { path: '/salesorders/', linkedColumn: 'sales_order_no' },
    },
    invoices: {
      tableHeaders: [
        t('ListTable.date'),
        t('Invoice.invoice_no'),
        t('Invoice.payment_due'),
        t('ListTable.amount'),
        t('ListTable.status'),
      ],
      tableData: [
        'invoice_date',
        'invoice_no',
        'payment_due',
        'total',
        'status',
      ],
      rightAlignColumns: [3, 4],
      linkTo: { path: '/invoices/', linkedColumn: 'invoice_no' },
    },
    packages: {
      tableHeaders: [
        t('ListTable.slip_no'),
        t('ListTable.date'),
        t('ListTable.status'),
      ],
      tableData: ['package_no', 'package_date', 'status'],
      linkTo: { path: '/packages/', linkedColumn: 'package_no' },
    },
    payments_received: {
      tableHeaders: [
        t('ListTable.date'),
        t('ListTable.payment_no'),
        t('Invoice.menu.invoice_no'),
        t('Invoice.reference'),
        t('Invoice.amount'),
        t('Items.type'),
      ],
      tableData: [
        'payment_date',
        'payment_no',
        'invoice_no',
        'reference',
        'amount',
        'payment_mode',
        '',
      ],
      rightAlignColumns: [3],
    },
    purchase_orders: {
      tableHeaders: [
        t('PurchaseOrder.purchase_order_no'),
        t('ListTable.date'),
        t('saleOrder.reference'),
        t('Invoice.amount'),
        t('ListTable.status'),
      ],
      tableData: [
        'purchase_order_no',
        'order_date',
        'reference',
        'total',
        'status',
      ],
      rightAlignColumns: [4],
      linkTo: {
        path: '/purchaseorders/',
        linkedColumn: 'purchase_order_no',
      },
    },
    purchase_receives: {
      tableHeaders: [
        t('PurchaseOrder.receive_no.'),
        t('PurchaseOrder.purchase_order_no'),
        t('ListTable.date'),
        t('ListTable.quantity'),
      ],
      tableData: [
        'receive_no',
        'purchase_order_no',
        'receive_date',
        'received_quantity',
      ],
      rightAlignColumns: [4],
    },
    bills: {
      tableHeaders: [
        t('bill.bill_no'),
        t('ListTable.date'),
        t('ListTable.due'),
        t('ListTable.amount'),
        t('ListTable.status'),
      ],
      tableData: ['bill_no', 'bill_date', 'balance_due', 'total', 'status'],
      rightAlignColumns: [3, 4],
      linkTo: { path: '/bills/', linkedColumn: 'bill_no' },
    },
    payments_made: {
      tableHeaders: [
        t('ListTable.date'),
        t('saleOrder.reference'),
        t('ListTable.amount'),
        t('Items.type'),
      ],
      tableData: ['payment_date', 'reference', 'amount', 'payment_mode'],
      rightAlignColumns: [3],
    },
    sales_return: {
      tableHeaders: [
        t('ListTable.sale_return_no'),
        t('ListTable.date'),
        t('ListTable.add_to_stock'),
        t('ListTable.return_quantity'),
        t('ListTable.status'),
      ],
      tableData: [
        'sales_return_no',
        'sales_return_date',
        'back_stock',
        'return_quantity',
        'status',
      ],
      rightAlignColumns: [0],
      linkTo: { path: '/salesreturns/', linkedColumn: 'sales_return_no' },
    },
    credit_notes: {
      tableHeaders: [
        t('CreditNote.cn_no'),
        t('ListTable.date'),
        t('Invoice.menu.invoice_no'),
        t('ListTable.credit'),
        t('ListTable.status'),
      ],
      tableData: [
        'credit_note_no',
        'credit_note_date',
        'invoice_no',
        'issued_credits',
        'status',
      ],
      rightAlignColumns: [0],
      linkTo: { path: '/creditnotes/', linkedColumn: 'credit_note_no' },
    },
  };

  filterOptions = []; // options available for current contact depending on contact type
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingList: true,
      activeTab: '',
      list: [],
      currency: {},
      currentTab:
        this.props.contactType === 'vendor' ? 'purchaseOrders' : 'salesOrder',
    };
  }

  componentDidMount() {
    this.fetchData(
      this.props.contactType === 'vendor' ? 'purchase_orders' : 'sales_orders'
    );
    this.setState({ loading: true });
  }
  fetchData(value) {
    this.setState({ loading: true });
    restRequest(
      'get',
      `contacts/${this.props.contactId}/transaction?filter=${value}`
    )
      .then((res) => {
        this.setState({
          loading: false,
          data:
            value === 'payments_received'
              ? res.transactions.data
              : res.transactions,
          currency: res.base_currency,
        });
        this.renderTableData(value);
      })
      .catch((err) => {
        this.setState({ loading: false });
        checkError(err);
      });
  }

  getNewPath(path, value) {
    // const queryContactNAme = queryString.parse(this.props.location.search);

    var url = `?filter=all&sort=created_at&page=1&orderBy=desc&view=20&contactId=${this.props.contactId}`;
    if (
      (path && path.includes('salesorders')) ||
      value.includes('sales_orders')
    ) {
      return `/salesorders${url}`;
    } else if (
      (path && path.includes('invoices')) ||
      value.includes('invoices')
    ) {
      return `/invoices${url}`;
    } else if (
      (path && path.includes('packages')) ||
      value.includes('packages')
    ) {
      return `/packages${url}`;
    } else if (
      (path && path.includes('paymentsmade')) ||
      value.includes('payments_received')
    ) {
      return `/paymentsmade${url}`;
    } else if (
      (path && path.includes('salesreturns')) ||
      value.includes('sales_return')
    ) {
      return `/salesreturns${url}`;
    } else if (
      (path && path.includes('creditnotes')) ||
      value.includes('credit_notes')
    ) {
      return `/creditnotes${url}`;
    } else if (
      (path && path.includes('purchaseorders')) ||
      value.includes('purchase_orders')
    ) {
      return `/purchaseorders${url}`;
    } else if ((path && path.includes('bills')) || value.includes('bills')) {
      return `/bills${url}`;
    } else {
      return null;
    }
  }
  concatCurrencySymbol = (data, currency, value) => {
    if (value === 'purchase_orders') {
      return data.map((item) => {
        return {
          id: item.id,
          purchase_order_no: item.purchase_order_no,
          order_date: item.order_date
            ? item.order_date.split(' ')[0]
            : item.order_date,
          reference: item.reference,
          total: currency.symbol + parseFloat(item.total)?.toFixed(2),
          status:
            // item.status
            item.status === 'draft'
              ? t('Items.draft')
              : item.status === 'closed'
              ? t('Items.closed')
              : item.status === 'confirmed'
              ? t('Items.confirmed')
              : item.status === 'issued'
              ? t('Items.issued')
              : item.status === 'cancelled'
              ? t('Items.cancelled')
              : item.status,
        };
      });
    } else if (value === 'bills') {
      return data.map((item) => {
        return {
          id: item.id,
          bill_no: item.bill_no,
          bill_date: item.bill_date
            ? item.bill_date.split(' ')[0]
            : item.bill_date,
          balance_due:
            currency.symbol + parseFloat(item.balance_due).toFixed(2),
          total: currency.symbol + parseFloat(item.total)?.toFixed(2),
          status:
            item.status === 'draft'
              ? t('Items.draft')
              : item.status === 'paid'
              ? t('Items.paid')
              : item.status === 'overdue'
              ? t('Items.overdue')
              : item.status,
        };
      });
    } else if (value === 'payments_made') {
      return data.map((item) => {
        return {
          id: item.id,
          payment_date: item.payment_date
            ? item.payment_date.split(' ')[0]
            : item.payment_date,
          reference: item.reference,
          amount: currency.symbol + parseFloat(item.amount)?.toFixed(2),
          payment_mode: item.payment_mode,
        };
      });
    } else if (value === 'sales_orders') {
      return data.map((item) => {
        return {
          id: item.id,
          sales_order_no: item.sales_order_no,
          order_date: item.order_date
            ? item.order_date.split(' ')[0]
            : item.order_date,
          reference: item.reference,
          total: currency.symbol + parseFloat(item.total)?.toFixed(2),
          status:
            item.status === 'draft'
              ? t('Items.draft')
              : item.status === 'closed'
              ? t('Items.closed')
              : item.status === 'confirmed'
              ? t('Items.confirmed')
              : item.status,
        };
      });
    } else if (value === 'invoices') {
      return data.map((item) => {
        return {
          id: item.id,
          invoice_date: item.invoice_date
            ? item.invoice_date.split(' ')[0]
            : item.invoice_date,
          invoice_no: item.invoice_no,
          payment_due:
            item.currency.symbol +
            parseFloat(item.exchanged_payment_due)?.toFixed(2),
          total:
            item.currency.symbol + parseFloat(item.exchanged_total)?.toFixed(2),
          status:
            item.status === 'draft'
              ? t('Items.draft')
              : item.status === 'paid'
              ? t('Items.paid')
              : item.status === 'overdue'
              ? t('Items.overdue')
              : item.status,
        };
      });
    } else if (value === 'payments_received') {
      return data.map((item) => {
        return {
          id: item.invoice_id,
          payment_no: item.payment_no,
          payment_date: item.payment_date
            ? item.payment_date.split(' ')[0]
            : item.payment_date,
          reference: item.reference,
          amount:
            item.currency.symbol +
            parseFloat(
              item.payment_made == null ? '00.00' : item.payment_made
            )?.toFixed(2),
          payment_mode: item.payment_mode,
          invoice_no: item.invoice_no,
        };
      });
    } else if (value === 'credit_notes') {
      return data.map((item) => {
        return {
          id: item.id,
          credit_note_no: item.credit_note_no,
          credit_note_date: item.credit_note_date
            ? item.credit_note_date.split(' ')[0]
            : item.credit_note_date,
          invoice_no: item.invoice_no,
          issued_credits:
            item.invoice.currency.symbol +
            parseFloat(item.exchanged_issued_credits)?.toFixed(2),
          status:
            item.status === 'draft'
              ? t('Items.draft')
              : item.status === 'open'
              ? t('Items.open')
              : item.status === 'consumed'
              ? t('Items.consumed')
              : item.status,
        };
      });
    } else if (value === 'packages') {
      return data.map((item) => {
        return {
          id: item.id,
          package_date: item.package_date
            ? item.package_date.split(' ')[0]
            : item.package_date,
          package_no: item.package_no,
          status:
            item.status === 'not shipped'
              ? t('Packages.pkg_status.not_shipped')
              : item.status === 'shipped'
              ? t('Packages.pkg_status.shipped')
              : item.status === 'delivered'
              ? t('Packages.pkg_status.delivered')
              : item.status,
        };
      });
    } else if (value === 'sales_return') {
      return data.map((item) => {
        return {
          id: item.id,
          sales_return_date: item.sales_return_date
            ? item.sales_return_date.split(' ')[0]
            : item.sales_return_date,
          sales_return_no: item.sales_return_no,
          back_stock: item.back_stock,
          return_quantity: item.return_quantity,
          status:
            item.status === 'received'
              ? t('Items.received')
              : item.status === 'confirmed'
              ? t('Items.confirmed')
              : item.status === 'draft'
              ? t('Items.draft')
              : item.status,
        };
      });
    } else {
      return this.state.data;
    }
  };
  renderTableData = (value, title, path) => {
    let newPath = this.getNewPath(path, value);
    const { data, currency } = this.state;
    const dataAfterConcatination = this.concatCurrencySymbol(
      data,
      currency,
      value
    );
    return (
      <div
        className={`${
          value === 'purchase_receives' ? 'contact_purchase_receives' : ''
        }`}
      >
        <TabsTable
          value={value}
          data={dataAfterConcatination}
          loading={this.state.loading}
          contactId={this.props.contactId}
          inModal={this.props.inModal}
        />
        {
          //displaying view all button on basis of length of data also if title of tab if missing then no button dispaly.
          !this.props.inModal && this.state.data.length > 0 && title && (
            <button
              className="next-btn transaction transaction_view_btn"
              onClick={() => {
                localStorage.setItem('contactName', this.props.contactName);
                this.props.history.push(newPath);
              }}
            >
              {t('Settings.view_all')}{' '}
              {title === 'Sales Order'
                ? t('Settings.sales_order')
                : title === 'Invoices'
                ? t('Items.invoices')
                : title === 'Packages'
                ? t('Packages.packages')
                : title === 'Payments Received'
                ? t('Payments.payments_received')
                : title === 'Sales Return'
                ? t('Items.sales_returns')
                : title === 'Credit Notes'
                ? t('Items.credit_notes')
                : title === 'Purchase Orders'
                ? t('Settings.purchase_order')
                : title}
            </button>
          )
        }
      </div>
    );
  };

  renderTransactions(tab) {
    if (this.state.loadingList) {
      return <Loader />;
    }
    if (this.state.list.length === 0) {
      return <EmptyTable />;
    }
    return (
      <TransactionsTable
        list={this.state.list}
        tableHeaders={this.transactionTable[tab].tableHeaders}
        tableData={this.transactionTable[tab].tableData}
        rightAlignColumns={this.transactionTable[tab].rightAlignColumns}
        linkTo={this.transactionTable[tab].linkTo}
        className="list-table"
        currencySymbol={this.state.currency.symbol}
      />
    );
  }

  handleTabChange(tab, val = '') {
    this.fetchData(val);
    this.setState({ currentTab: tab });
  }

  tabsForCustomers = [
    //sending two more parameters in renderContent func second is title of button and third is path
    ///if title missing button will not be dispalyed
    {
      id: 'salesOrder',
      label: t('saleOrder.sales_orders'),
      onClick: () => {
        this.handleTabChange('salesOrder', 'sales_orders');
      },
      renderContent: () =>
        this.renderTableData('sales_orders', 'Sales Order', 'salesorders'),
    },
    {
      id: 'invoice',
      label: t('Invoice.title_secondary'),
      onClick: () => {
        this.handleTabChange('invoice', 'invoices');
      },
      renderContent: () =>
        this.renderTableData('invoices', 'Invoices', 'invoices'),
    },
    {
      id: 'package',
      label: t('Packages.packages'),
      onClick: () => {
        this.handleTabChange('package', 'packages');
      },
      renderContent: () =>
        this.renderTableData('packages', 'Packages', 'packages'),
    },
    {
      id: 'paymentsReceived',
      label: t('Invoice.payment_received'),
      onClick: () => {
        this.handleTabChange('paymentsReceived', 'payments_received');
      },
      renderContent: () =>
        this.renderTableData(
          'payments_received',
          'Payments Received',
          'paymentsmade'
        ),
    },
    {
      id: 'salesReturn',
      label: t('saleOrder.sales_return'),
      onClick: () => {
        this.handleTabChange('salesReturn', 'sales_return');
      },
      renderContent: () =>
        this.renderTableData('sales_return', 'Sales Return', 'salesreturns'),
    },
    {
      id: 'creditNotes',
      label: t('Settings.credit_notes'),
      onClick: () => {
        this.handleTabChange('creditNotes', 'credit_notes');
      },
      renderContent: () =>
        this.renderTableData('credit_notes', 'Credit Notes', 'creditnotes'),
    },
  ];

  tabsForVendors = [
    {
      id: 'purchaseOrders',
      label: t('Settings.purchase_orders'),
      onClick: () => {
        this.handleTabChange('purchaseOrders', 'purchase_orders');
      },
      renderContent: () =>
        this.renderTableData(
          'purchase_orders',
          'Purchase Orders',
          'purchaseorders'
        ),
    },
    {
      id: 'purchaseReceives',
      label: t('common.purchase_receive'),
      onClick: () => {
        this.handleTabChange('purchaseReceives', 'purchase_receives');
      },
      renderContent: () => this.renderTableData('purchase_receives'),
    },

    {
      id: 'bills',
      label: t('bill.bills'),
      onClick: () => {
        this.handleTabChange('bills', 'bills');
      },
      renderContent: () => this.renderTableData('bills', 'Bills', 'bills'),
    },
    {
      id: 'paymentsMade',
      label: t('CreditNote.payments_made'),
      onClick: () => {
        this.handleTabChange('paymentsMade', 'payments_made');
      },
      renderContent: () => this.renderTableData('payments_made'),
    },
  ];
  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <SubTabs
        tabs={
          this.props.contactType === 'vendor'
            ? this.tabsForVendors
            : this.tabsForCustomers
        }
        currentTab={this.state.currentTab}
      />
    );
  }
}

export default ContactTransactionTab;
